import InformeAlberguesIngreso from "../components/Caracterizacion/Administrativos/InformeAlberguesIngreso";
import Juridico from "../components/Caracterizacion/Reparacion/Juridico";
import AtencionPsicosocial from "../components/Caracterizacion/Reparacion/AtencionPsicosocial";
import ListarAtencionesPsicosociales from "../components/Caracterizacion/Reparacion/ListarAtencionesPsicosociales";
import ListarAtencionesJuridicas from "../components/Caracterizacion/Reparacion/ListarAtencionesJuridicas";
import CargarCedula from "../components/Caracterizacion/Personas/CargarCedula";


export const CaracterizacionRoutes = [
    { path: '/albergues/informe/alberguesingreso', element: <InformeAlberguesIngreso /> },
    { path: '/caracterizacion/psicosocial/:idCabezaFamilia/:idDerivacion', element: <AtencionPsicosocial /> },
    { path: '/caracterizacion/juridico/:idCabezaFamilia/:idDerivacion', element: <Juridico /> },
    { path: '/caracterizacion/listaratencionpsicosocial/:idCabezaFamilia', element: <ListarAtencionesPsicosociales /> },
    { path: '/caracterizacion/listaratencionjuridica/:idCabezaFamilia', element: <ListarAtencionesJuridicas /> },
    { path: '/caracterizacion/cargarcedulas/:idCabezaFamilia', element: <CargarCedula /> },
];